import { Layout, Row, Typography } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { FILE_STATUS, REQUEST_LOADING_STATES, THUMBNAIL_TYPES } from "../../helpers/constant";
import { createScrollHandler } from "../../helpers/scrolling/scroll";
import useFetchFeeds from "../../hooks/feedHooks/useFetchFeeds";
import { getOtherUserFeedsById, getUserFeeds, updateFile } from "../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../redux/store";
import { authService } from "../../services";
import { socket } from "../../socket";
import ArrowLeftIconComponent from "../ArrowLeftIconComponent";
import MainSwiperSlideItemV2 from "../MainSwiperSlideItemV2/MainSwiperSlideItemV2";
import { FanHomePageSkelton } from "../SkeltonsComponents/FanHomePageSkelton";
import "./index.less";

function CreatorPublicationSwiper() {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const targetRef = useRef<HTMLDivElement | null>(null);
  const { id, userID } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isMyProfile = params.get("isMyProfile") === "true";
  // const shouldFetch = useRef(true);
  // const { list, currentUserFeeds, loading } = useSelector((state: StoreState) => state.feeds);
  // const [feeds, setFeeds] = useState<IFeed[]>([]);
  const { loading, feeds: feedsData } = useFetchFeeds(userID || "", isMyProfile);
  const { currentFeedsPage, otherFeedsPage } = useSelector((state: StoreState) => state.feeds);
  const containerRef = useRef(null);
  const [loadedMore, setLoadedMore] = useState<boolean>(false); //keep track if we're loading more data
  const [isPage, setIsPage] = useState<boolean>(false); //protection so the the view doesn't scroll back to element we clicked first time
  // const startingPageCount = isMyProfile ? currentFeedsPage : otherFeedsPage;
  // const [loadedMore, setLoadedMore] = useState<boolean>(false);
  useEffect(() => {
    // if (shouldFetch.current) {
    //   shouldFetch.current = false;
    //   if (isMyProfile) {
    //     if (currentUserFeeds.length === 0) {
    //       dispatch(getMyFeeds());
    //     } else {
    //       setFeeds(currentUserFeeds);
    //     }
    //   } else {
    //     if (list.length === 0 || list[0]?.sourceId !== userID) {
    //       dispatch(getFeedsByCreatorId({ creatorId: userID! }));
    //     } else {
    //       setFeeds(list);
    //     }
    //   }
    // }

    function handleFileUpdated(data: { fileId: string; absolutePath: string; thumbnails: any; status: string }) {
      dispatch(updateFile(data));
    }

    socket.on("file-updated", handleFileUpdated);

    return () => {
      socket.off("file-updated", handleFileUpdated);
    };
  }, []);

  // useEffect(() => {
  //   if (isMyProfile) {
  //     setFeeds(currentUserFeeds);
  //   } else {
  //     setFeeds(list);
  //   }
  // }, [list, currentUserFeeds, isMyProfile]);

  useEffect(() => {
    if (feedsData && feedsData?.feeds.length > 0 && targetRef.current !== null && !isPage) {
      targetRef.current.scrollIntoView({ behavior: "auto", block: "start", inline: "start" });
    }
  }, [feedsData?.feeds.length]);

  const loadMoreFeed = () => {
    if (feedsData && feedsData.hasMore && userID !== "" && !isMyProfile) {
      dispatch(getOtherUserFeedsById({ creatorId: userID!, page: otherFeedsPage }));
    }
    if (feedsData && feedsData.hasMore && userID !== "" && isMyProfile) {
      dispatch(getUserFeeds(currentFeedsPage));
    }
    setLoadedMore(false);
  };

  const handleScroll = useCallback(
    createScrollHandler({
      isLoading: loading === REQUEST_LOADING_STATES.SUCCEEDED,
      hasLoadedMore: loadedMore,
      hasMore: feedsData?.hasMore ?? false,
      onLoadMore: loadMoreFeed,
      onSetLoadedMore: setLoadedMore,
      onSetIsPage: setIsPage,
    }),
    [loading, loadedMore, feedsData, loadMoreFeed, setLoadedMore, setIsPage]
  );

  return (
    <div>
      <Layout>
        <Layout.Header className="header">
          <Row className="relative justify-content-center">
            <ArrowLeftIconComponent top={10} />
            <Typography.Text className="header-title-black-35">{t("publications")}</Typography.Text>
          </Row>
        </Layout.Header>
        {
          <Layout.Content className="content fanFeedDetailsContentWrapper no-scrollbar" ref={containerRef} onScroll={handleScroll}>
            <div className="pub-content-container">
              {feedsData?.feeds?.map((feed) => {
                let thumbnail = "";
                let fileUrl = "";
                let isUploading: boolean = false;
                if (feed.files !== undefined) {
                  isUploading = feed.files[0].status === FILE_STATUS.UPLOADING;
                  if (!isUploading) {
                    if (!feed.isPrivateForCurrentUser) {
                      fileUrl = feed.files[0].url!;
                      thumbnail = feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.CLEAR)?.absolutePath!;
                    } else {
                      thumbnail = feed.files[0].thumbnails?.find((thumb) => thumb.type === THUMBNAIL_TYPES.BLURRED)?.absolutePath!;
                      fileUrl = thumbnail;
                    }
                  }
                }
                return (
                  <MainSwiperSlideItemV2
                    refProp={id === feed._id ? targetRef : null}
                    key={feed._id}
                    feedId={feed._id!}
                    name={feed.creatorInfo?.name!}
                    username={feed.creatorInfo?.username!}
                    avatar={feed.creatorInfo?.avatar!}
                    creatorId={feed.creatorInfo?._id}
                    totalLikes={feed.totalLike}
                    fileUrl={fileUrl}
                    thumbnail={thumbnail}
                    isLiked={feed.isLiked}
                    isBookMarked={feed.isBookMarked}
                    isPrivate={feed.isPrivateForCurrentUser}
                    description={feed.text!}
                    verifiedAccount={feed.creatorInfo?.verifiedAccount}
                    type={feed.type!}
                    isCurrentUser={feed.creatorInfo?._id === authService.getId()}
                    isUploading={isUploading}
                    isMyProfile={isMyProfile}
                    creatorIds={feed?.creatorIds || []}
                  />
                );
              })}
            </div>
            <FanHomePageSkelton loading={loading === "pending"} />
          </Layout.Content>
        }
        {/* {authService.getRole() === "creator" ? (
          <FooterComponent type="creator" page={FOOTER_IDS.PROFILE} />
        ) : (
          <FooterComponent type="fan" page={FOOTER_IDS.PROFILE} />
        )} */}
      </Layout>
    </div>
  );
}

export default CreatorPublicationSwiper;
